export const snackbarDataDeleted = "Dati eliminati";
export const snackbarResetChat = "Chat resettata";
export const snackbarDataUploaded = "Dati caricati";
export const snackbarEditSource = "Fonte modificata";
export const snackbarEditSourceSuccessSubTitlePart2 =
  "” è stata modificata con successo. Le modifiche della fonte verranno disabilitate fino alla fine dell'elaborazione.";
export const snackbarDetailEmailSentToUser =
  "Abbiamo inviato un'email all'indirizzo specificato";
export const snackbarDetailSuccessSendEmail =
  "Controlla la tua casella di posta";
export const snackbarDetailUpdatesSaved =
  "Le modifiche sono state salvate con successo";
export const snackbarEmailSentToSpecifiedEmail =
  "Abbiamo inviato una email all’indirizzo specificato";
export const snackbarEmailSentToSpecifiedEmails =
  "Abbiamo inviato una email agl’indirizzi specificati";
export const snackbarFeedbackSubTitle =
  "I tuoi suggerimenti aiutano a mantenere Simonbot affidabile!";
export const snackbarLimitRefershSubTitle =
  "Non è stato possibile rigenerare la risposta, hai raggiunto il limite di rigenerazioni per questa risposta";
export const snackbarLimitRefershTitle = "Limite rigenerazioni raggiunto";
export const snackbarFeedbackTitle = "Grazie per il feedback";
export const snackbarProjectLimitSharedMax = "Limite condivisione raggiunto ";
export const snackbarProjectLimitSharedMaxSubTitle =
  "Il limite massimo consentito per la condivisione simultanea del materiale è 10";
export const snackbackPasswordUpdateSuccessTitle = "Password modificata";
export const snackbackPasswordUpdateSuccessSubTitle =
  "La password è stata modificata con successo";
export const snackbarProjectDeletedSubTitlePart1 = "Il progetto ";
export const snackbarProjectDeletedSubTitlePart2 =
  " è stato eliminato con successo";
export const snackbarProjectAbandonedSubTitlePart1 = "Il progetto ";
export const snackbarProjectAbandonedSubTitlePart2 =
  " è stato abbandonato con successo";
export const snackbarProjectDeletedTitle = "Progetto eliminato";
export const snackbarProjectAbandonedTitle = "Progetto abbandonato";
export const snackbarRegistrationCompletedSubTitle =
  "Adesso puoi accedere in piattaforma";
export const snackbarRegistrationCompletedTitle = "Registrazione completata";
export const snackbarRemovedAnswerSubTitle =
  "Le risposta è stata rimossa con successo";
export const snackbarRemovedAnswerTitle = "Risposta rimossa";
export const snackbarRemovedAnswersSubTitle =
  "Le risposte selezionate sono state rimosse con successo";
export const snackbarRemovedAnswersTitle = "Risposte rimosse";
export const snackbarSendEmail = "Email inviata con successo";
export const snackbarSendEmails = "Email inviate con successo";
export const snackbarSendEmailSubtitle =
  "Abbiamo inviato le mail all'indirizzo specificato";
export const snackbarSendEmailsSubtitle =
  "Abbiamo inviato le mail agli indirizzi specificati";
export const snackbarSeverityInfo = "info";
export const snackbarSeveritySuccess = "success";
export const snackbarSourceNotReady =
  "La fonte è ancora in fase di elaborazione";
export const snackbarSummarySourceAddSuccessSubTitlePart1 = "La fonte “";
export const snackbarSummarySourceAddSuccessSubTitlePart2 =
  "” è stata caricata con successo. Le modifiche della fonte verranno disabilitate fino alla fine dell'elaborazione.";
export const snackbarSummarySourceDeleteSuccessSubTitlePart2 =
  "” è stata eliminata con successo";
export const snackbarSummarySuccessAddProject = "Progetto creato";
export const snackbarSummarySuccessAddProjectSubTitlePart1 = "Il progetto ";
export const snackbarSummarySuccessAddProjectSubTitlePart2 =
  " è stato creato con successo";
export const snackbarSummarySuccessAddSource = "Nuova fonte aggiunta";
export const snackbarSummarySuccessAddSourceSubTitle =
  "La fonte è stata aggiunta con successo";
export const snackbarSummarySuccessEditProject = "Progetto rinominato";
export const snackbarSummarySuccessEditProjectSubTitle =
  "Il progetto è stato rinominato con successo";
export const snackbarSummaryLengthErrorEditProject = "Errore";
export const snackbarSummaryLengthErrorEditProjectSubTitle =
  "Massimo numero di caratteri è 75.";
export const snackbarSummarySuccessSendEmail = "Email inviata con successo";
export const snackbarSummarySuccessUpdateAnswerSubTitle =
  "La risposta selezionata è stata rinominata con successo ";
export const snackbarSummarySuccessUpdateAnswerTitle = "Risposta rinominata";
export const snackbarSummaryTopicAddSuccessSubTitlePart1 = "Il topic “";
export const snackbarSummaryTopicAddSuccessSubTitlePart2 =
  "” è stato aggiunto con successo";
export const snackbarSummaryTopicAddSuccessTitle = "Topic aggiunto";
export const snackbarSummaryTopicDeleteSuccessSubTitlePart1 = "Il topic “";
export const snackbarSummaryTopicDeleteSuccessSubTitlePart2 =
  "” è stato eliminato con successo";
export const snackbarSummaryTopicUpdatedSuccessTitle = "Topic modificato ";
export const snackbarSummaryTopicUpdatedSuccessSubTitlePart1 = "Il topic “";
export const snackbarSummaryTopicUpdatedSuccessSubTitlePart2 =
  "” è stato modificato con successo";
export const snackbarSummaryUpdatesSaved = "Modifiche salvate";
export const snackbarTopicDeleted = "Topic eliminato";
export const snackbarUserRemovedFromProjectSubTitlePart1 = "L'Utente ";
export const snackbarUserRemovedFromProjectSubTitlePart2 =
  "è stato rimosso dal progetto";
export const snackbarUserRemovedFromProjectTitle = "Utente rimosso";
export const snackbarUserDeleted = "User eliminato";
export const snackbarUserDeletedSubTitle =
  "L'Utente è stato eliminato dalla piattaforma";
export const snackbarUserUpdated = "L'utente è stato modificato con successo";
export const snackbarReportResolvedTitle = "Segnalazione risolta";
export const snackbarReportResolvedSubTitleCorrect =
  "Continueremo a mostrare questa risposta";
export const snackbarReportResolvedSubTitleWarning =
  "Non mostreremo più questa risposta";
export const snackbarReportResolvedSubTitlePartiallyWarning =
  "Mostreremo la risposta con le correzioni che hai effettuato";
export const snackbarSummaryFeedbackSentSuccessTitle = "Grazie per il feedback";
export const snackbarSummaryFeedbackSentSuccessSubTitle =
  "I tuoi suggerimenti aiutano a mantenere Simonbot affidabile!";
export const snackbarSummaryResetChatSubTitle = "La chat verrà resettata a causa della modifica delle fonti";
